import _defineProperty from '@babel/runtime/helpers/defineProperty';
import message from 'element-ui/lib/message';
import 'element-ui/lib/theme-chalk/message.css';
import KDVueMessage from '@kdocs/kdesign-vue/lib/message';
import '@kdocs/kdesign-vue/lib/theme-chalk/message.css';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var KMessage = {};
var _loop = function _loop(method) {
  KMessage[method] = function () {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (method !== 'close' && method !== 'closeAll') {
      message.closeAll();
    }
    if (typeof opts === 'string') {
      opts = {
        message: opts
      };
    }
    opts = _objectSpread(_objectSpread({
      customClass: 'k-el-message'
    }, opts), {}, {
      offset: opts.offset || 96
    });

    // iframe里边的ui组件将message抛出至上层window使用场景
    if (window.$__APPLICATION_PLATFORM && window.$__APPLICATION_PLATFORM.todo) {
      var eventName = 'called_by_contact_selector_message';
      var _message = JSON.stringify({
        eventName: eventName,
        type: method,
        content: opts.message
      });
      return window.parent.postMessage(_message, '*');
    }
    return message[method](opts);
  };
};
for (var method in message) {
  _loop(method);
}
var KDMessage = {};
var _loop2 = function _loop2(_method) {
  KDMessage[_method] = function () {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (_method !== 'close' && _method !== 'closeAll') {
      KDVueMessage.closeAll();
    }
    if (typeof opts === 'string') {
      opts = {
        message: opts
      };
    }
    opts = _objectSpread(_objectSpread({
      customClass: 'k-el-message'
    }, opts), {}, {
      top: opts.offset || 96
    });

    // iframe里边的ui组件将message抛出至上层window使用场景
    if (window.$__APPLICATION_PLATFORM && window.$__APPLICATION_PLATFORM.todo) {
      var eventName = 'called_by_contact_selector_message';
      var _message2 = JSON.stringify({
        eventName: eventName,
        type: _method,
        content: opts.message
      });
      return window.parent.postMessage(_message2, '*');
    }
    return KDVueMessage[_method](opts);
  };
};
for (var _method in KDVueMessage) {
  _loop2(_method);
}
var KDesignMessage = KDMessage;

export { KDesignMessage, KMessage as default };
